import React from 'react'
import vlogimg from '../../Images/vlogimg.png'
import '../../Styles/Blogs.css';

export default function Blogs() {
  return (
   
      <div className='container py-5'>
        <div className='row'>
          <div className='col-sm-6'>
          <div className='row'>
            <img src={vlogimg} alt='Blogs'></img></div>
          </div>
          <div className='col-sm-6 d-flex justify-content-center align-item-center flex-column' >
            <div className="heading2 pb-3 mx-4">Learning! Skill Up</div>
            <div className='blogcontent mx-4'>At VetLearn, we believe that true growth comes from a blend of knowledge, practical exposure, and personal exploration. Our programs are designed not just to teach concepts, but to immerse learners in real-world experiences that prepare them for the challenges of the dairy, poultry, and companion animal health industries.

By combining structured learning with hands-on training and expert mentorship, we help individuals discover their potential, sharpen their skills, and confidently pursue their professional goals.</div>
          </div>
        </div>
      </div>

   
  )
}
